import React from "react";
import "./app.scss";
import { ButtonScrollTop } from "./components/buttonScrollTop";
// import AdvancedSecurity from "./pages/advancedSecurity";
// import DataManagement from "./pages/dataManagement";
// import Home from "./pages/home";
// import Connectors from "./pages/connectors";
// import RealtimeData from "./pages/realtimeData";
import Routers from "./routers";


import './i18n'
import CookieConsent from "react-cookie-consent";
import { useTranslation } from "react-i18next";

function App() {

  const {t} = useTranslation()

  return (
    <div className="container-general">
      <Routers />
      <ButtonScrollTop />
      <CookieConsent 
        buttonStyle={{backgroundColor: "#68ba6f", color: "#FFF", height: "45px"}}
        buttonText={t("cookie_consent.button_text")}
        style={{backgroundColor: "#FFF", color: "#000"}}
      >
        <p>{t("cookie_consent.section_text_1")}</p>
      </CookieConsent>
    </div>
  );
}

export default App;
